import React from "react";
import { Link } from "react-router-dom";
import { FaLock, FaWhatsapp, FaPhoneAlt } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-zinc-800 text-white py-8 relative">
      {/* First Row */}
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
        {/* About Section */}
        <div>
          <h3 className="font-bold text-lg mb-4">About</h3>
          <img
            src="/assets/images/logo.jpg"
            className="w-40 h-48 py-4 rounded-full"
            alt="footer_logo"
          />
          <p className="text-lg space-y-3">
            Yuvraj Mehandi is dedicated to providing exceptional Mehandi
            artistry and services. Our skilled artists aim to deliver the best
            designs and experiences for your special occasions.
          </p>
        </div>
        {/* Services Section */}
        <div>
          <h3 className="font-bold text-lg mb-4">Services</h3>
          <ul className="text-lg space-y-3">
            <li className="hover:text-yellow-400 cursor-pointer">
              Bridal Mehandi
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Traditional Mehandi
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Arabic Mehandi Designs
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Festival Mehandi
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Engagement Mehandi
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Customized Mehandi Designs
            </li>
          </ul>
        </div>

        {/* Quick Links Section */}
        <div>
          <h3 className="font-bold text-lg mb-4">Quick Links</h3>
          <ul className="text-lg space-y-3">
            <li>
              <Link to="/" className="hover:text-yellow-400 cursor-pointer">
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="hover:text-yellow-400 cursor-pointer"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link
                to="/services"
                className="hover:text-yellow-400 cursor-pointer"
              >
                Services
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className="hover:text-yellow-400 cursor-pointer"
              >
                Contact
              </Link>
            </li>
            <li>
              <Link
                to="/refer"
                className="hover:text-yellow-400 cursor-pointer"
              >
                Refer & Earn
              </Link>
            </li>
            <li>
              <Link
                to="/pay-now"
                className="hover:text-yellow-400 cursor-pointer"
              >
                Pay Now
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Details Section */}
        <div>
          <h3 className="font-bold text-lg mb-4">Contact Details</h3>
          <ul className="text-lg space-y-3">
            <li className="hover:text-yellow-400 cursor-pointer">
              Phone: +91 8376911727
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Whatsapp: +91 9354020727
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Email: info@yuvrajmehandi.com
            </li>
            <li className="hover:text-yellow-400 cursor-pointer">
              Address: Rohini sector 1 Avantika market shop No. 485, Zipcode
              110086
            </li>
          </ul>
          <div className="flex items-center space-x-2 border mt-11 border-gray-500 rounded p-2">
            <FaLock className="text-yellow-500 text-4xl" />
            <span className="font-bold">
              SSL Encryption <br /> secure connection
            </span>
          </div>
          <div className="mt-11 rounded-lg p-2">
            <h3 className="font-bold text-lg mb-4">Refer to Friends</h3>
            <img src="/assets/refer/yovraj.png" alt="" />
          </div>
        </div>
      </div>
      <div className="text-center p-4 py-4 lg:px-20">
        <p className="text-lg text-yellow-400">
          Delhi: Connaught Place | Chandni Chowk | Saket | Karol Bagh | Hauz
          Khas | Lajpat Nagar | Rohini | Dwarka | Vasant Kunj | Janakpuri |
          Rajouri Garden | Pitampura | Greater Kailash | Mayur Vihar | Shahdara
          | South Extension | Uttar Pradesh: Lucknow | Kanpur | Agra | Varanasi
          | Allahabad (Prayagraj) | Meerut | Ghaziabad | Bareilly | Aligarh |
          Moradabad | Gorakhpur | Jhansi | Mathura | Ayodhya | Saharanpur |
          Noida | Firozabad | Muzaffarnagar | Rae Bareli | Faizabad
        </p>
      </div>

      {/* Second Row */}
      <div className="text-center py-4 mt-8">
        <p className="text-lg cursor-pointer">
          &copy; 2025 Yuvraj Mehandi. All rights reserved & Developed By
          <Link
            className="text-yellow-400"
            to="https://divywebb.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            Divy Webb Creation
          </Link>
        </p>
      </div>

      {/* Bottom Right Icons */}
      <div className="fixed bottom-8 right-8 flex flex-col items-center space-y-4">
        {/* WhatsApp Icon */}
        <a
          href="https://wa.link/mv3bes"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 p-4 rounded-full shadow-md hover:scale-110 transition-transform duration-300 animate-bounce"
        >
          <FaWhatsapp className="text-white text-2xl" />
        </a>
        {/* Call Icon */}
        <a
          href="tel:+919354020727"
          className="bg-blue-500 p-4 rounded-full shadow-md hover:scale-110 transition-transform duration-300 animate-bounce"
        >
          <FaPhoneAlt className="text-white text-2xl" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
